import React from 'react'

import PointsTableWithImage from '../../_shared/PointsTableWithImage'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

import { getImages, findReplyByQuestionName } from '../../_helpers/pdfHelpers'

const WorkEnvSection = ({ serviceOrder }) => {
  const imagemAreaInterna = getImages(findReplyByQuestionName(serviceOrder.replies, 'FOTO GERAL DAS ÁREAS INTERNAS'), 0)
  return (
    <View id="12">
      <Text bold size="small">
        12. CONDIÇÕES FÍSICAS DO AMBIENTE DE TRABALHO
      </Text>

      <Separator weight={8} />

      <Text bold size="small">
        12.1. ÁREAS DE CIRCULAÇÃO
      </Text>

      <Separator weight={4} />

      <Text>
        A circulação dentro da empresa é uma parte importante do trabalho cotidiano. Um tráfego fluente entre os postos
        de trabalho é um requisito prévio para um local de trabalho produtivo. A circulação dos colaboradores em pisos
        desiguais, ou escorregadios são causas frequentes de acidentes. Tais acidentes são eliminados propiciando-se
        boas vias de circulação.
        <br />
        Serão avaliadas as áreas de circulação (amostragem) das instalações da empresa.
      </Text>

      <Separator weight={8} />

      <PointsTableWithImage
        tipo={'areaInterna'}
        title="Áreas Internas"
        image={imagemAreaInterna}
        sections={[
          {
            label: 'Requisitos Ergonômicos de Boas Práticas',
            rows: [
              {
                label: 'As áreas de circulação se encontram livres e desimpedidas',
                value: true
              },
              {
                label: 'Existem desníveis sinalizados',
                value: true
              },
              {
                label:
                  'Os pontos de lógica e elétrica são dispostos em posições que não geram situações de risco no caso de suas utilizações (exemplo: fios no meio da circulação ou passagem de colaboradores)',
                value: true
              },
              {
                label:
                  'Em locais de circulação de máquinas e pessoas, há a sinalização diferenciada para a circulação das mesmas.',
                value: true
              },
              {
                label: 'Não existem depressões no terreno que ofereçam riscos a máquinas e pessoas.',
                value: true
              },
              {
                label:
                  'No interior das dependências da empresa não há situações de arranjo inadequado que ofereçam risco aos colaboradores',
                value: true
              }
            ]
          }
        ]}
      />

      <Separator weight={8} />
    </View>
  )
}

export default WorkEnvSection
